<template>
    <div class="mono-icon" ref="monoIcon">
        <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="m10 4c-2.20914 0-4 1.79086-4 4 0 2.2091 1.79086 4 4 4 2.2091 0 4-1.7909 4-4 0-2.20914-1.7909-4-4-4zm-6 4c0-3.31371 2.68629-6 6-6 3.3137 0 6 2.68629 6 6 0 3.3137-2.6863 6-6 6-3.31371 0-6-2.6863-6-6zm17.6644 3.2526c.4127.3669.4499.999.083 1.4118l-2.6667 3c-.1897.2135-.4617.3356-.7474.3356-.2856 0-.5576-.1221-.7474-.3356l-1.3333-1.5c-.3669-.4128-.3297-1.0449.083-1.4118.4128-.3669 1.0449-.3297 1.4118.083l.5859.6592 1.9193-2.1592c.3669-.4127.999-.4499 1.4118-.083zm-15.1644 6.7474c-1.25946 0-2.5 1.2135-2.5 3 0 .5523-.44772 1-1 1s-1-.4477-1-1c0-2.6318 1.89347-5 4.5-5h7c2.6065 0 4.5 2.3682 4.5 5 0 .5523-.4477 1-1 1s-1-.4477-1-1c0-1.7865-1.2405-3-2.5-3z" fill="#0d0d0d"/></svg>
    </div>
</template>

<script>
export default {
  name: 'UserCheckIcon',
  props: {
    size: {
        type: String,
        default: '24'
    },
    color: {
        type: String,
        default: '#434343'
    }
  },
  methods: {
    update() {
      this.$refs.monoIcon.children[0].children.forEach(child => child.setAttribute('fill', ''))
      this.$refs.monoIcon.children[0].setAttribute('fill', this.color)
      this.$refs.monoIcon.children[0].setAttribute('height', this.size)
      this.$refs.monoIcon.children[0].setAttribute('width', this.size)
    }
  },
  watch: {
    size() {
      this.update()
    },
    color() {
      this.update()
    }
  },
  mounted() {
    this.update()
  }
}
</script>